import { AppLocale } from "src/localization/localization"

export function getLocaleOrThrow(): AppLocale {
  return "de"
}
